import React from 'react';
import {Bar} from 'react-chartjs-2';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper';

const data = {
  labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
  datasets: [
    {
      label: 'settled',
      backgroundColor: '#2196f3',
      borderColor: '#2196f3',
      borderWidth: 1,
      hoverBackgroundColor: '#0566b3',
      hoverBorderColor: '#0566b3',
      data: [65000, 59000, 80000, 81000, 56000, 55000, 40000]
    }
  ]
};

const styles = theme => ({
  chartWrapper: {
    overflowX: 'auto',
    padding: '30px',
    width: 'auto',
    height: 'auto',
    minWidth: '300px',
    marginTop: '30px'
  }
});

class SettlementReport extends React.Component {
  data = () => {
    const { settlements } = this.props;

    return {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'settled',
          backgroundColor: '#2196f3',
          borderColor: '#2196f3',
          borderWidth: 1,
          hoverBackgroundColor: '#0566b3',
          hoverBorderColor: '#0566b3',
          data: [65000, 59000, 80000, 81000, 56000, 55000, 40000]
        }
      ]
    }
  }

  render = () => {
    return (
      <Paper className={this.props.classes.chartWrapper}>
        <Typography variant='title'>
          Settlements
        </Typography>
        <Bar
          data={data}
          options={{
            maintainAspectRatio: false
          }}
        />
      </Paper>
    );
  }
}
const styled = withStyles(styles)(SettlementReport);
export default styled;



// WEBPACK FOOTER //
// ./src/components/Dashboard/SettlementReport.js